import { type TraPayload } from '#app/services/ai/types.ts'
import { type LegalSourceCitationBehavior } from '#app/services/legal-ai/shared/source-contract.ts'
import { normalizeResolutionLikeCitationLeadIn } from '#app/services/legal-ai/shared/resolution-citation-lead-in.ts'
import { capitalizeAllWords } from '#app/utils/text.js'

type TraCitationPayload = Omit<TraPayload, 'content'> & { id: string | number }

export function getTraDocumentUrl(traPayload: TraCitationPayload): string {
	return traPayload.file_url || traPayload.detail_url || `/enlace/tra/${traPayload.idDocument}`
}

export const traDocumentAsTitle = (traPayload: TraCitationPayload) => {
	return capitalizeAllWords(traPayload.title || `Voto ${traPayload.vote}-${traPayload.year ?? ''}`, true)
}

export function normalizeTraCitationLeadIn(leadIn: string, payload: TraCitationPayload) {
	const vote = String(payload.vote ?? '').trim()
	const year = String(payload.year ?? '').trim()
	if (!vote || !year) return leadIn
	const canonicalNumber = new RegExp(`(?:-|/)${year}$`).test(vote) ? vote.replace('/', '-') : `${vote}-${year}`
	return normalizeResolutionLikeCitationLeadIn({ leadIn, canonicalNumber, labelPattern: 'voto' })
}

export const costaRicaTraCitation: LegalSourceCitationBehavior<TraPayload> = {
	title: traDocumentAsTitle,
	url: getTraDocumentUrl,
	inlineTagName: 'tradocument',
	modelAlias: { prefix: 'TRA' },
	normalizeCitationLeadIn: normalizeTraCitationLeadIn,
	legacyTagNames: ['TraDocument', 'tra-document'],
	fallbackUrl: documentId => `/enlace/tra/${documentId}`,
	iconName: 'gavel',
	linkClassName: 'text-violet-600',
	inlineSecondaryText: payload => payload.category,
	summaryLabel: 'votos TRA',
	summaryIconName: 'gavel',
	summaryIconClassName: 'text-violet-500',
	summaryDotClassName: 'bg-violet-500',
	summaryTitle: payload => payload.title,
}
